// @flow
import { sortBy, toUpper, uniqBy } from 'lodash';

import { type EventFormResort } from 'Components/widgets/event-form/EventForm';

export type EventResortProps = {
  id: string,
  name: string,
  destination: {
    area: string,
  },
};

export const getEventFormResorts = (resorts: Array<EventResortProps>): Array<EventFormResort> =>
  sortBy(
    uniqBy(resorts, 'id').map(({ id, name, destination }) => ({
      id,
      name,
      region: destination.area,
    })),
    resort => toUpper(resort.name),
  );

export const getEventFormRegions = (resorts: Array<EventFormResort>): Array<string> =>
  Array.from(new Set(resorts.map(resort => resort.region))).sort();
